module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyBAMAAABYG2ONAAAAD1BMVEXNKj7ecn////+BnohDb0034HfXAAAAJklEQVR4AWNhIBmMXC2jWka1CJKnZTSQR7WMahnNYgOvZVTLqBYAVK0BDTB0dX0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/hu.png
// module id = 2im5
// module chunks = 0